module.exports = __webpack_public_path__ + "static/media/section.d4f539a5.png";